/**
 * Black Diamond cookie-consent shell behavior.
 *
 * A choice is stored locally so the presentation only appears on the first
 * visit in this browser. This file does not change the site's cookie policy;
 * it only handles the consent prompt's display state.
 */
(() => {
  const consent = document.querySelector('[data-cookie-consent]');
  if (!consent) return;

  const storageKey = 'bd-cookie-consent';
  const acceptButton = consent.querySelector('[data-cookie-consent-accept]');
  const declineButton = consent.querySelector('[data-cookie-consent-decline]');

  const readChoice = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const saveChoice = (choice) => {
    try {
      window.localStorage.setItem(storageKey, choice);
    } catch (error) {
      // The dialog still closes when storage is unavailable for this browser.
    }
  };

  const closeConsent = (choice) => {
    saveChoice(choice);
    consent.dataset.cookieConsentState = choice;
    consent.classList.remove('is-visible');
    consent.hidden = true;
    consent.setAttribute('aria-hidden', 'true');
  };

  if (readChoice()) {
    consent.hidden = true;
    consent.setAttribute('aria-hidden', 'true');
    return;
  }

  consent.classList.add('is-visible');

  acceptButton?.addEventListener('click', () => closeConsent('accepted'));
  declineButton?.addEventListener('click', () => closeConsent('declined'));
})();
